import * as React from "react";
import { useEffect } from "react";
import { getIn, useFormikContext } from "formik";
import { FormikInput, Spinner } from "components/common";
import { Input } from "components/bootstrap";
import AppConfig from "util/AppConfig";
import { formatArchiveRetentionTime } from "./archiveRetention";
import { getArchiveRetentionLabels, globalRetentionHelp } from "./archiveRetentionLabels";
import useIndexSetArchiveSettings from "./useIndexSetArchiveSettings";
const OVERRIDE_FIELD = "archive_retention_override_enabled";
const RETENTION_TIME_FIELD = "archive_retention_time";
const ArchiveRetentionFields = ({
  valuesPrefix = void 0,
  archivingEnabled,
  hiddenFields = [],
  immutableFields = [],
  ignoreFieldRestrictions = false
}) => {
  var _a;
  const { values, setFieldValue } = useFormikContext();
  const fieldName = (field) => valuesPrefix ? `${valuesPrefix}.data_tiering.${field}` : `data_tiering.${field}`;
  const restrictionName = (field) => `data_tiering.${field}`;
  const restricted = (field) => !ignoreFieldRestrictions && (immutableFields.includes(restrictionName(field)) || immutableFields.includes("data_tiering"));
  const hidden = !ignoreFieldRestrictions && [OVERRIDE_FIELD, RETENTION_TIME_FIELD].some((field) => hiddenFields.includes(restrictionName(field)));
  const showFields = archivingEnabled && !AppConfig.isCloud() && !hidden;
  const { globalRetentionTime, isLoading } = useIndexSetArchiveSettings({ enabled: showFields });
  const ARCHIVE_RETENTION_LABELS = getArchiveRetentionLabels();
  const overridePath = fieldName(OVERRIDE_FIELD);
  const retentionTimePath = fieldName(RETENTION_TIME_FIELD);
  const overrideEnabled = (_a = getIn(values, overridePath)) != null ? _a : false;
  const retentionTime = getIn(values, retentionTimePath);
  const restrictedOverride = restricted(OVERRIDE_FIELD);
  const restrictedRetentionTime = restricted(RETENTION_TIME_FIELD);
  useEffect(() => {
    if (!showFields || restrictedRetentionTime) {
      return;
    }
    if (overrideEnabled) {
      const neverSet = retentionTime === null || retentionTime === void 0;
      if (neverSet && globalRetentionTime !== void 0) {
        setFieldValue(retentionTimePath, globalRetentionTime);
      }
      return;
    }
    if (retentionTime !== null && retentionTime !== void 0) {
      setFieldValue(retentionTimePath, null);
    }
  }, [
    showFields,
    overrideEnabled,
    retentionTime,
    globalRetentionTime,
    retentionTimePath,
    restrictedRetentionTime,
    setFieldValue
  ]);
  if (!showFields) {
    return null;
  }
  if (isLoading) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    FormikInput,
    {
      type: "checkbox",
      id: ARCHIVE_RETENTION_LABELS.overrideId,
      label: ARCHIVE_RETENTION_LABELS.overrideLabel,
      name: overridePath,
      help: ARCHIVE_RETENTION_LABELS.overrideHelp,
      disabled: restrictedOverride
    }
  ), overrideEnabled ? /* @__PURE__ */ React.createElement(
    FormikInput,
    {
      type: "number",
      id: ARCHIVE_RETENTION_LABELS.retentionTimeId,
      label: ARCHIVE_RETENTION_LABELS.retentionTimeLabel,
      name: retentionTimePath,
      min: 0,
      help: ARCHIVE_RETENTION_LABELS.retentionTimeHelp,
      required: true,
      disabled: restrictedRetentionTime
    }
  ) : /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      id: ARCHIVE_RETENTION_LABELS.globalId,
      label: ARCHIVE_RETENTION_LABELS.retentionTimeLabel,
      value: formatArchiveRetentionTime(globalRetentionTime),
      placeholder: ARCHIVE_RETENTION_LABELS.globalPlaceholder,
      help: globalRetentionHelp(globalRetentionTime),
      onChange: () => {
      },
      disabled: true
    }
  ));
};
export default ArchiveRetentionFields;
